import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text,
  Button,
  Flex,
  Image,
} from "@chakra-ui/react";
import { Fatura,  Pix } from "../../utils/interfaces";
import { formatBRL } from "../../utils/currency";
import { useEffect, useState } from "react";
import { useMutationPix } from "../../hooks/pagamento/mutationPix";
import { AxiosErrorResponse } from "../../hooks/pdv/mutationReserva";
import Swal from "sweetalert2";
import { MdPix } from "react-icons/md";
import { api } from "../../libs/axios";
import { queryClient } from "../../libs/queryClient";
import { PixTimerFooter } from '../../components/Modal/PixTimerFooter';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  fatura: Fatura;
}


export function ModalPix({ isOpen, onClose, fatura }: Props){
  const [pix, setPix] = useState<Pix | null>(null);

  const mutation = useMutationPix(fatura.id, true);

  const fetchPixStatus = async (id: string) => {
    const response = await api.get(`/checkout/pix/consultar/fatura/${id}`);

    return response.data;
  }

  useEffect(() => {
    const gerarPix = async () => {
      try {
        const pix = await mutation.mutateAsync()

        setPix(pix)
      }catch (err){
        const error = err as AxiosErrorResponse

        const requestId = error.response?.headers?.['request-id'];
        
        Swal.fire({
          title: "Ocorreu um erro",
          icon: "error",
          text: `${error.response?.data?.data?.message || "Erro desconhecido"} ${requestId ? `- Request ID: ${requestId}` : ''}`,
        })

        onClose()
        setPix(null)
      }
    }

    if(isOpen){
      setPix(null);
      gerarPix()
    } 
  }, [fatura.id, isOpen])

  useEffect(() => {
    let interval: ReturnType<typeof setTimeout>;

    const verificarPagamento = async () => {
      try {
        await fetchPixStatus(fatura.id);

          Swal.fire({
            icon: "success",
            title: "Pagamento confirmado!",
            text: "Pix recebido com sucesso",
          });

          clearInterval(interval);
          onClose();
          queryClient.invalidateQueries({
            queryKey: ['faturas'], exact: false,
          })
          window.location.href = `/fatura-finalizada/${fatura.id}`;
      }catch (err: unknown) {
        console.log(err);
      }
    };

    if (isOpen) {
      interval = setInterval(verificarPagamento, 10000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [isOpen, fatura.id, onClose]);

  useEffect(() => {
    if (isOpen) {
      console.log('[PIX MODAL] aberto, estado pix:', pix);
    }
  }, [isOpen, pix]);

  return (
    <Modal
      size={"4xl"}
      key={"pagamento-dinheiro"}
      closeOnOverlayClick={false}
      isOpen={isOpen}
      onClose={() => {
        onClose();
        setPix(null);
      }}
    >
      <ModalOverlay />
      <ModalContent bg={'#f4f4f4'}>
        <ModalHeader>PAGAMENTO PIX - DETALHES DO PAGAMENTO</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <Flex
            mb={4}
            alignItems={"end"}
            justifyContent={"space-between"}
            w={"100%"}
          >
            <Text fontSize={"lg"}>VALOR TOTAL DA FATURA</Text>
            <Text fontSize={"3xl"} fontWeight={"bold"} textAlign={"right"}>
              {formatBRL(Number(fatura.valor_total))}
            </Text>
          </Flex>
          <Flex gap={2} flexDir={'column'} alignItems={'center'} justifyContent={'center'}>
            {pix?.qrCode ? (
              <Image 
                src={pix.qrCode} 
                alt="QR Code do pagamento PIX"
                key={pix.qrCode}
              />
            ):(
              <Text fontSize="sm" color="red.500">
                QR Code não disponível no momento.
              </Text>
            )}
            <Text bg={'gray.200'} borderRadius={'md'} p={2} textAlign={'center'} maxW={"100%"} wordBreak={"break-all"} whiteSpace={"normal"} overflowWrap={"anywhere"}>{pix?.dados_qrcode}</Text>
            <Button leftIcon={<MdPix />} onClick={async () => {
              await navigator.clipboard.writeText(pix?.dados_qrcode ?? '')
              Swal.fire({
                icon:'success',
                title: 'Sucesso',
                text: 'O PIX foi copiado para área de transferência',
              })
            }}>Copiar PIX Copia e Cola</Button>
          </Flex>
        </ModalBody>
        <PixTimerFooter 
          isOpen={isOpen}
          dataExpiracao={pix?.data_expiracao ?? ""}
        />
      </ModalContent>
    </Modal>
  );
}